import axios from 'axios'

import i18n, { DefaultLanguage } from 'app/i18/i18'

import {
  getLocalStore,
  removeLocalStore,
  setLocalStore,
} from '../lib/local-store'

export const API_URL = import.meta.env.VITE_API_URL

export const clientApi = axios.create({
  baseURL: API_URL,
  headers: { 'X-Source-Request': 'MBANK' },
})

const COUNT_RELOAD = 5

const listAuthUrls = ['/auth/login', '/profile']

function setResponseInterceptors() {
  clientApi.interceptors.response.use(
    (response) => {
      return Promise.resolve(response)
    },
    (error) => {
      const isAuthUrl = listAuthUrls.some((url) =>
        error?.request?.responseURL?.includes(url),
      )

      if (error.response && error.response.status === 401 && isAuthUrl) {
        const countReloadCurrent = parseInt(getLocalStore('countReload') || '0')

        if (COUNT_RELOAD >= countReloadCurrent) {
          removeLocalStore('mTravelToken')
          location.reload()
          setLocalStore('countReload', `${countReloadCurrent + 1}`)
        }
      }

      return Promise.reject(error)
    },
  )

  clientApi.interceptors.request.use(
    (config) => {
      const token = getLocalStore('mTravelToken')
      const deviceId = getLocalStore('mTravelDeviceId')
      const language = i18n.language || DefaultLanguage

      if (token?.length) config.headers['Authorization'] = `Bearer ${token}`

      if (deviceId) config.headers['X-Device-Id'] = deviceId

      if (language) config.headers['Accept-Language'] = language

      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )
}

setResponseInterceptors()
